import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { supabase } from "../supabase/client";
import { userErrorMessage } from "../utils/userErrorMessage";

export default function TossReturn() {
  const [sp] = useSearchParams();
  const navigate = useNavigate();
  const [msg, setMsg] = useState("승인 중...");

  useEffect(() => {
    (async () => {
      const paymentKey = sp.get("paymentKey");
      const orderId = sp.get("orderId");
      const amount = Number(sp.get("amount") || 0);
      const postId = sp.get("postId");
      const applicationId = sp.get("appId");

      try {
        if (!paymentKey || !orderId || !amount) throw new Error("파라미터 누락");
        // Edge Function 호출
        const { data, error } = await supabase.functions.invoke("confirm-toss-payment", {
          body: { postId, applicationId, paymentKey, orderId, amount }
        });
        if (error || !data?.ok) throw new Error(data?.error || error?.message || "승인 실패");
        setMsg("결제가 보류(에스크로)로 승인되었습니다.");
        setTimeout(() => navigate(`/bus-hub/${postId}/manage`), 1200);
      } catch (e) {
        setMsg("승인 실패: " + userErrorMessage(e));
      }
    })();
  }, [navigate, sp]);

  return <div className="p-6 text-sm">{msg}</div>;
}
